<template>
    <el-form class="performance-assess-detail-score-form" ref="formRef" :model="form" :rules="rules" label-width="160px" size="mini">
        <el-row v-if="isAdd">
            <el-col :span="6">
                <el-form-item label="供应商名称" prop="supplierName">
                    <SrmAdvance
                        :mValue="form.supplierName"
                        :params="supplierAdvanceConfig"
                        :formData="supplierAdvanceConfig.formData"
                        @getAdvanceValue="getSupplierAdvance"
                    />
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="经营中心" prop="centerName">
                    <SrmAdvance
                        :mValue="form.centerName"
                        :params="businessAdvanceConfig"
                        @getAdvanceValue="getCenterAdvance"
                    />
                </el-form-item>
            </el-col>
            <!-- <el-col :span="6">
                <el-form-item label="逻辑仓" prop="logicalWarehouseName">
                    <SrmAdvance
                        :mValue="form.logicalWarehouseName"
                        :params="logicalWhAdvanceConfig"
                        :formData="{ cdwhIsStop: '0' }"
                        @getAdvanceValue="getWhAdvance"
                    />
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="仓库类型" prop="warehouseType">
                    <MSelect
                        :optionNum="'WH_CATEGORY'"
                        :value="form.warehouseType"
                        :placeholder="'仓库类型'"
                        :filterable="true"
                        @input="handleSelect"
                    ></MSelect>
                </el-form-item>
            </el-col> -->
            <el-col class="lh-28" :span="6"><span class="label-span">运作质量:</span><span class="value-span">{{ assessmentOperationalQualityText }}</span></el-col>
        </el-row>
        <el-row v-if="isEdit || isAudit || isDetail" class="flex-row mb-18 big-bold-text">
            <el-col :span="6"><span class="label-span">运作质量:</span><span class="value-span">{{ assessmentOperationalQualityText }}</span></el-col>
        </el-row>
        <el-row v-if="isEdit || isAudit || isDetail" class="flex-row mb-18">
            <el-col :span="6"><span class="label-span">分公司:</span><span class="value-span">{{ form.companyName }}</span></el-col>
            <el-col :span="6"><span class="label-span">经营中心:</span><span class="value-span">{{ form.centerName }}</span></el-col>
            <!-- <el-col :span="6"><span class="label-span">逻辑仓:</span><span class="value-span">{{ form.logicalWarehouseName }}</span></el-col> -->
            <el-col :span="12"><span class="label-span">供应商名称:</span><span class="value-span">{{ form.supplierName }}</span></el-col>
        </el-row>
        <el-row class="flex-row mb-18">
            <el-col :span="6"><span class="label-span">考核月份:</span><span class="value-span">{{ form.assessmentMonth }}</span></el-col>
            <el-col :span="6"><span class="label-span">考核得分:</span><span class="value-span">{{ form.assessmentScore }}</span></el-col>
            <el-col :span="6"><span class="label-span">KPI考核得分:</span><span class="value-span">{{ form.kpiAssessmentScore }}</span></el-col>
            <el-col :span="6"><span class="label-span">异常得分:</span><span class="value-span">{{ form.abnormalAssessmentScore }}</span></el-col>
        </el-row>
        <el-row :class="isDetail ? 'flex-row mb-18' : ''">
            <template v-if="isDetail">
                <el-col :span="6"><span class="label-span">月业务规模(元):</span><span class="value-span">{{ form.monthlyBusinessScale }}</span></el-col>
                <el-col :span="6"><span class="label-span">月罚扣款(元):</span><span class="value-span">{{ form.monthlyPenaltyDeduction }}</span></el-col>
            </template>
            <template v-else>
                <el-col :span="6">
                    <el-form-item label="月业务规模(元)" prop="monthlyBusinessScale" :class="isHeightLightLabel('monthlyBusinessScale') ? 'height-light-label-item' : ''">
                        <el-input v-model.trim="form.monthlyBusinessScale" :disabled="isAudit || computeDisabled" @input="computeScore"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="月罚扣款(元)" prop="monthlyPenaltyDeduction" :class="isHeightLightLabel('monthlyPenaltyDeduction') ? 'height-light-label-item' : ''">
                        <el-input v-model.trim="form.monthlyPenaltyDeduction" :disabled="isAudit || computeDisabled" @input="computeScore"></el-input>
                    </el-form-item>
                </el-col>
            </template>
            <el-col :span="6"><span class="label-span">质量损失率(%):</span><span class="value-span">{{ form.qualityLossRate }}</span></el-col>
            <el-col :span="6"><span class="label-span">质量损伤率得分:</span><span class="value-span">{{ form.qualityLossScore }}</span></el-col>
        </el-row>
        <el-row :class="isDetail ? 'flex-row mb-18' : ''">
            <template v-if="isDetail">
                <el-col :span="6"><span class="label-span">出库-总单量(不含剔除):</span><span class="value-span">{{ form.outboundTotalOrders }}</span></el-col>
                <el-col :span="6"><span class="label-span">出库-及时单量:</span><span class="value-span">{{ form.outboundTimelyOrders }}</span></el-col>
            </template>
            <template v-else>
                <el-col :span="6">
                    <el-form-item label="出库-总单量(不含剔除)" prop="outboundTotalOrders" :class="isHeightLightLabel('outboundTotalOrders') ? 'height-light-label-item' : ''">
                        <el-input v-model.trim="form.outboundTotalOrders" :disabled="isAudit || computeDisabled" @input="handleTotalInput"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="出库-及时单量" prop="outboundTimelyOrders" :class="isHeightLightLabel('outboundTimelyOrders') ? 'height-light-label-item' : ''">
                        <el-input v-model.trim="form.outboundTimelyOrders" :disabled="isAudit || computeDisabled" @input="computeScore"></el-input>
                    </el-form-item>
                </el-col>
            </template>
            <el-col :span="6"><span class="label-span">出库及时率(%):</span><span class="value-span">{{ form.outboundTimelyRate }}</span></el-col>
            <el-col :span="6"><span class="label-span">出库及时率得分:</span><span class="value-span">{{ form.outboundTimelyScore }}</span></el-col>
        </el-row>
        <el-row :class="isDetail ? 'flex-row mb-18' : ''">
            <template v-if="isDetail">
                <el-col :span="6"><span class="label-span">入库-总单量(不含剔除):</span><span class="value-span">{{ form.inboundTotalOrders }}</span></el-col>
                <el-col :span="6"><span class="label-span">入库-及时单量:</span><span class="value-span">{{ form.inboundTimelyOrders }}</span></el-col>
            </template>
            <template v-else>
                <el-col :span="6">
                    <el-form-item label="入库-总单量(不含剔除)" prop="inboundTotalOrders" :class="isHeightLightLabel('inboundTotalOrders') ? 'height-light-label-item' : ''">
                        <el-input v-model.trim="form.inboundTotalOrders" :disabled="isAudit || computeDisabled" @input="handleTotalInput"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="入库-及时单量" prop="inboundTimelyOrders" :class="isHeightLightLabel('inboundTimelyOrders') ? 'height-light-label-item' : ''">
                        <el-input v-model.trim="form.inboundTimelyOrders" :disabled="isAudit || computeDisabled" @input="computeScore"></el-input>
                    </el-form-item>
                </el-col>
            </template>
            <el-col :span="6"><span class="label-span">入库及时率(%):</span><span class="value-span">{{ form.inboundTimelyRate }}</span></el-col>
            <el-col :span="6"><span class="label-span">入库及时率得分:</span><span class="value-span">{{ form.inboundTimelyScore }}</span></el-col>
        </el-row>
        <el-row :class="isDetail ? 'flex-row mb-18' : ''">
            <template v-if="isDetail">
                <el-col :span="6"><span class="label-span">在职人员:</span><span class="value-span">{{ form.activeEmployees }}</span></el-col>
                <el-col :span="6"><span class="label-span">离职人数:</span><span class="value-span">{{ form.resignedEmployees }}</span></el-col>
            </template>
            <template v-else>
                <el-col :span="6">
                    <el-form-item label="在职人员" prop="activeEmployees" :class="isHeightLightLabel('activeEmployees') ? 'height-light-label-item' : ''">
                        <el-input v-model.trim="form.activeEmployees" :disabled="isAudit || computeDisabled" @input="computeScore"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="离职人数" prop="resignedEmployees" :class="isHeightLightLabel('resignedEmployees') ? 'height-light-label-item' : ''">
                        <el-input v-model.trim="form.resignedEmployees" :disabled="isAudit || computeDisabled" @input="computeScore"></el-input>
                    </el-form-item>
                </el-col>
            </template>
            <el-col :span="6"><span class="label-span">离职率(%):</span><span class="value-span">{{ form.resignationRate }}</span></el-col>
            <el-col :span="6"><span class="label-span">离职率得分:</span><span class="value-span">{{ form.resignationRateScore }}</span></el-col>
        </el-row>
        <el-row v-if="isEdit || isAudit">
            <!-- 仓储绩效整改-流程信息 -->
            <el-col :span="6" v-if="isAudit && isPerformanceAdjustment">
                <el-form-item label="附件" prop="supplierLspMipAttachmentFileName" class="upload-item" :class="isHeightLightLabel('supplierLspMipAttachmentFileName') ? 'height-light-label-item' : ''">
                    <el-input v-model="form.supplierLspMipAttachmentFileName" readonly :disabled="isAudit">
                        <template slot="append"><upload :accept="accept" :fileTypeReg="fileTypeReg" :disabled="isAudit" @uploadSuccess="handleUpload"></upload></template>
                    </el-input>
                    <el-button v-if="form.supplierLspMipAttachmentFileUrl" type="text" size="mini" class="preview-btn" @click="handlePreview">预览</el-button>
                </el-form-item>
            </el-col>
            <!-- 绩效考核明细-编辑、流程和修改记录 -->
            <el-col :span="6" v-else>
                <el-form-item label="附件" prop="attachmentFileName" class="upload-item" :class="isHeightLightLabel('attachmentFileName') ? 'height-light-label-item' : ''">
                    <el-input v-model="form.attachmentFileName" readonly :disabled="isAudit">
                        <template slot="append"><upload :accept="accept" :fileTypeReg="fileTypeReg" :disabled="isAudit" @uploadSuccess="handleUpload"></upload></template>
                    </el-input>
                    <el-button v-if="form.attachmentFileUrl" type="text" size="mini" class="preview-btn" @click="handlePreview">预览</el-button>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row v-if="isDetail" class="flex-row mb-18">
            <el-col :span="22">
                <span class="label-span">附件:</span>
                <span class="value-span">{{ form.attachmentFileName }}</span>
                <el-button v-if="form.attachmentFileUrl" type="text" size="mini" class="detail-preview-btn" @click="handlePreview">预览</el-button>
            </el-col>
        </el-row>
        <el-row v-if="isDetail" class="flex-row">
            <el-col :span="22">
                <span class="label-span">备注说明:</span><span class="value-span">{{ form.remark }}</span>
            </el-col>
        </el-row>
        <el-row v-else>
            <el-col :span="24">
                <el-form-item label="备注说明" prop="remark" :class="isHeightLightLabel('remark') ? 'height-light-label-item' : ''">
                    <el-input type="textarea"  v-model.trim="form.remark" :rows="3" :maxlength="200" :disabled="isAudit" show-word-limit></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <Preview
            v-if="attachmentShow"
            :attachmentList="attachmentList"
            :attachmentShow.sync="attachmentShow"
            :rowData="rowData"
        ></Preview>
    </el-form>
</template>
<script>
import dayjs from 'dayjs';
import { dictWithUrl } from '@/components/lots/api';
import { computePerformance } from '../../../api/warehouseResourceManagement/performanceAssessDetail.js';
import SrmAdvance from '../../../components/srmAdvance/index.vue';
import MSelect from '@/components/lots/otpSelect2';
import Upload from '../../../components/upload/Index.vue';
import Preview from '../../../components/viewAttachment.vue';
import { STORAGE_NUM, LOAD_AND_UNLOAD_NUM } from '../../../constant/constant.js'
import { logicalWhAdvanceConfig, businessAdvanceConfig } from '../../../constant/advanceConfig.js';

const INIT_FORM = {
    id: '',
    supplierCode: '',
    supplierName: '',
    // logicalWarehouseCode: '',
    // logicalWarehouseName: '',
    // warehouseType: '',
    assessmentOperationalQuality: '',
    assessmentScore: '',
    kpiAssessmentScore: '',
    abnormalAssessmentScore: '',
    monthlyBusinessScale: '',
    monthlyPenaltyDeduction: '',
    qualityLossRate: '',
    qualityLossScore: '',
    outboundTotalOrders: '',
    outboundTimelyOrders: '',
    outboundTimelyRate: '',
    outboundTimelyScore: '',
    inboundTimelyOrders: '',
    inboundTotalOrders: '',
    inboundTimelyRate: '',
    inboundTimelyScore: '',
    activeEmployees: '',
    resignedEmployees: '',
    resignationRate: '',
    resignationRateScore: '',
    remark: '',

    attachmentFileName: '',
    attachmentFileUrl: '',

    supplierLspMipAttachmentFileName: '',
    supplierLspMipAttachmentFileUrl: '',

    assessmentMonth: '',
    companyCode: '',
    companyName: '',
    siteCode: '',
    siteName: '',
    centerCode: '',
    centerName: '',

    performanceCode: '',
    dataSource: '',

    performanceType: '',
};

const numValidator1 = (rule, value, callback) => {
    if (!/^(\+|-)?\d{1,10}(\.\d{1,2})?$/.test(value) || Number(value) === 0) {
        callback(new Error('10位以内数字，支持2位小数，不支持0'));
    } else {
        callback();
    }
};

const numValidator2 = (rule, value, callback) => {
    if (!/^(\+|-)?\d{1,10}(\.\d{1,2})?$/.test(value)) {
        callback(new Error('10位以内数字，支持2位小数，支持0'));
    } else {
        callback();
    }
};

const intValidator = (rule, value, callback) => {
    if (!/^\+?\d{1,10}$/.test(value)) {
        callback(new Error('10位以内正整数，支持0'));
    } else {
        callback();
    }
};

export default {
    components: { SrmAdvance, MSelect, Upload, Preview },
    props: {
        operateType: {
            type: String,
            default: ''
        },
        // 是否仓储绩效整改页面
        isPerformanceAdjustment: {
            type: Boolean,
            default: false
        },
        currentPerformanceType: {
            type: String,
            default: ''
        },
        changeKeys: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            visible: false,
            loading: false,
            saveLoading: false,
            dict: {},
            accept: '.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx',
            fileTypeReg: /\.(jpg|jpeg|png|doc|docx|xls|xlsx)$/,
            attachmentShow: false,
            rowData: {},
            attachmentList: [],
            form: { ...INIT_FORM },
            rules: {
                supplierName: [
                    { required: true, message: '该项不能为空', trigger: ['blur', 'change'] }
                ],
                centerName: [
                    { required: true, message: '该项不能为空', trigger: ['blur', 'change'] }
                ],
                // logicalWarehouseName: [
                //     { required: true, message: '该项不能为空', trigger: ['blur', 'change'] }
                // ],
                // warehouseType: [
                //     { required: true, message: '该项不能为空', trigger: ['blur', 'change'] }
                // ],
                monthlyBusinessScale: [
                    { required: true, message: '该项不能为空', trigger: ['blur', 'change'] },
                    { validator: numValidator1, trigger: ['blur', 'change'] }
                ],
                monthlyPenaltyDeduction: [
                    { required: true, message: '该项不能为空', trigger: ['blur', 'change'] },
                    { validator: numValidator2, trigger: ['blur', 'change'] }
                ],
                outboundTotalOrders: [
                    { required: true, message: '该项不能为空', trigger: ['blur', 'change'] },
                    { validator: intValidator, trigger: ['blur', 'change'] }
                ],
                outboundTimelyOrders: [
                    { required: true, message: '该项不能为空', trigger: ['blur', 'change'] },
                    { validator: intValidator, trigger: ['blur', 'change'] },
                    { 
                        validator: (rule, value, callback) => {
                            if (!['', null, undefined].includes(this.form.outboundTotalOrders) && Number(value) > this.form.outboundTotalOrders) {
                                callback(new Error('不能大于出库-总单量(不含剔除)'));
                            } else {
                                callback();
                            }
                        },
                        trigger: ['blur', 'change']
                    },
                ],
                inboundTotalOrders: [
                    { required: true, message: '该项不能为空', trigger: ['blur', 'change'] },
                    { validator: intValidator, trigger: ['blur', 'change'] },
                ],
                inboundTimelyOrders: [
                    { required: true, message: '该项不能为空', trigger: ['blur', 'change'] },
                    { validator: intValidator, trigger: ['blur', 'change'] },
                    { 
                        validator: (rule, value, callback) => {
                            if (!['', null, undefined].includes(this.form.inboundTotalOrders) && Number(value) > this.form.inboundTotalOrders) {
                                callback(new Error('不能大于入库-总单量(不含剔除)'));
                            } else {
                                callback();
                            }
                        },
                        trigger: ['blur', 'change']
                    },
                ],
                activeEmployees: [
                    { required: true, message: '该项不能为空', trigger: ['blur', 'change'] },
                    { validator: intValidator, trigger: ['blur', 'change'] }
                ],
                resignedEmployees: [
                    { required: true, message: '该项不能为空', trigger: ['blur', 'change'] },
                    { validator: intValidator, trigger: ['blur', 'change'] }
                ],
                attachmentFileName: [
                    { required: true, message: '该项不能为空', trigger: ['blur', 'change'] }
                ],
                remark: [
                    { required: true, message: '该项不能为空', trigger: ['blur', 'change'] },
                    { max: 200, message: '不能超过200个字符', trigger: ['blur', 'change'] }
                ]
            },

            supplierAdvanceConfig: {
                name: '供应商',
                value: 'supplierName',
                advanceLabel: '供应商弹出框',
                advanceConfig: [
                    { prop: 'ALL', value: '全部' },
                    { prop: 'supplierCode', value: '供应商编码' },
                    { prop: 'supplierNameCn', value: '供应商名称' },
                ],
                tableConfig: [
                    { prop: 'supplierCode', value: '供应商编码' },
                    { prop: 'supplierNameCn', value: '供应商名称' },
                ],
                cbParams: [
                    'supplierCode#supplierCode',
                    'supplierNameCn#supplierName',
                    // 'supplierType#supplierType',
                    // 'propertyNature#property',
                ],
                advanceCascade: 'businessTypeList#businessTypeList,transTypeList#transTypeList',
                formData: { businessTypeList: [STORAGE_NUM, LOAD_AND_UNLOAD_NUM] },
                advanceUrl: `/supplier/supplierInfo/queryList`,
                prefix: 'api-srm-web',
                method: 'post',
            },
            // logicalWhAdvanceConfig: {
            //     ...logicalWhAdvanceConfig,
            //     cbParams: ['cdwhName#logicalWarehouseName', 'whCode#logicalWarehouseCode', 'companyCode', 'companyName', 'siteCode', 'siteName', 'centerCode', 'centerName'],
            //     advanceCascade: 'cdwhIsStop',
            // },
            businessAdvanceConfig: {
                ...businessAdvanceConfig,
                value: 'centerName',
                cbParams: ['companyCode', 'companyName', 'escoCompanyNo#centerCode', 'escoCompanyNameCn#centerName'],
            },
            computeTimeout: null
        };
    },
    computed: {
        isAdd() {
            return this.operateType === 'add';
        },
        isEdit() {
            return this.operateType === 'edit';
        },
        isDetail() {
            return this.operateType === 'detail';
        },
        isAudit() {
            return this.operateType === 'audit';
        },
        assessmentOperationalQualityText() {
            return this.dict.SRM_OPERATIONAL_QUALITY && this.form.assessmentOperationalQuality ?
                this.dict.SRM_OPERATIONAL_QUALITY[this.form.assessmentOperationalQuality] : '';
        },
        computeDisabled() {
            return ['assessmentMonth', 'supplierCode', 'centerCode'].some(key => ['', null, undefined].includes(this.form[key]))
        },
    },
    methods: {
        setData(data) {
            if (!data) {
                return false
            }
            Object.keys(this.form).forEach(key => {
                this.form[key] = [null, undefined, ''].indexOf(data[key]) < 0 ? data[key] : '';
            });
        },
        getData() {
            const params = JSON.parse(JSON.stringify(this.form));
            return params;
        },
        getSupplierAdvance(val) {
            this.form.supplierCode = val.supplierCode;
            this.form.supplierName = val.supplierName;
        },
        getCenterAdvance(val) {
            this.form.centerCode = val.centerCode
            this.form.centerName = val.centerName
            this.form.companyCode = val.companyCode
            this.form.companyName = val.companyName
        },
        // getWhAdvance(val) {
        //     this.form.logicalWarehouseCode = val.logicalWarehouseCode;
        //     this.form.logicalWarehouseName = val.logicalWarehouseName;
        //     this.form.companyCode = val.companyCode;
        //     this.form.companyName = val.companyName;
        //     this.form.siteCode = val.siteCode;
        //     this.form.siteName = val.siteName;
        //     this.form.centerCode = val.centerCode;
        //     this.form.centerName = val.centerName;
        // },
        // handleSelect(val) {
        //     this.form.warehouseType = val;
        // },
        handleUpload(val) {
            if (val.data && +val.data.code === 0) {
                this.form.attachmentFileName = val.data.data.localFileName;
                this.form.attachmentFileUrl = val.data.data.downUrl;
            }
        },
        handlePreview() {
            let isPerformanceAdjustment = false
            // 仓储绩效整改-流程信息弹窗取 supplierLspMipAttachmentFileUrl supplierLspMipAttachmentFileName
            if(this.isAudit && this.isPerformanceAdjustment) {
                isPerformanceAdjustment = true
            }
            this.rowData = {
                downUrl: isPerformanceAdjustment ? this.form.supplierLspMipAttachmentFileUrl : this.form.attachmentFileUrl,
                fileName: isPerformanceAdjustment ? this.form.supplierLspMipAttachmentFileName : this.form.attachmentFileName,
                // fileId: data.fileId
            };
            this.attachmentShow = true;
        },
        handleTotalInput(val) {
            let valid = false
            this.$refs.formRef.validateField('outboundTimelyOrders', (errorMessage) => {
                valid = !errorMessage
            })
            this.$refs.formRef.validateField('inboundTimelyOrders', (errorMessage) => {
                valid = !errorMessage
            })
            if (valid) {
                this.computeScore()
            }
        },
        computeScore() {
            clearTimeout(this.computeTimeout);
            const intKeys = ['outboundTotalOrders', 'outboundTimelyOrders', 'inboundTimelyOrders', 'inboundTotalOrders', 'activeEmployees', 'resignedEmployees'];
            if (
                (/^(\+|-)?\d{1,10}(\.\d{1,2})?$/.test(this.form.monthlyBusinessScale) && Number(this.form.monthlyBusinessScale) !== 0) &&
                /^(\+|-)?\d{1,10}(\.\d{1,2})?$/.test(this.form.monthlyPenaltyDeduction) &&
                intKeys.every(key => /^\+?\d{1,10}$/.test(this.form[key]))
            ) {
                this.computeTimeout = setTimeout(() => {
                    const params = {
                        performanceType: this.isAdd ? this.currentPerformanceType : this.form.performanceType,
                        assessmentMonth: this.form.assessmentMonth,
                        supplierCode: this.form.supplierCode,
                        centerCode: this.form.centerCode,
                        // logicalWarehouseCode: this.form.logicalWarehouseCode,
                        assessmentScore: this.form.assessmentScore,
                        kpiAssessmentScore: this.form.kpiAssessmentScore,
                        abnormalAssessmentScore: this.form.abnormalAssessmentScore,
                        monthlyBusinessScale: this.form.monthlyBusinessScale,
                        monthlyPenaltyDeduction: this.form.monthlyPenaltyDeduction
                    };
                    intKeys.forEach(key => {
                        params[key] = this.form[key];
                    });
                    this.$emit('computing', true);
                    computePerformance(params).then(res => {
                        if (res && +res.code === 0 && res.data) {
                            this.form.assessmentOperationalQuality = res.data.assessmentOperationalQuality;
                            this.form.assessmentScore = res.data.assessmentScore;
                            this.form.kpiAssessmentScore = res.data.kpiAssessmentScore;
                            this.form.abnormalAssessmentScore = res.data.abnormalAssessmentScore;
                            this.form.qualityLossRate = res.data.qualityLossRate;
                            this.form.qualityLossScore = res.data.qualityLossScore;
                            this.form.outboundTimelyRate = res.data.outboundTimelyRate;
                            this.form.outboundTimelyScore = res.data.outboundTimelyScore;
                            this.form.inboundTimelyRate = res.data.inboundTimelyRate;
                            this.form.inboundTimelyScore = res.data.inboundTimelyScore;
                            this.form.resignationRate = res.data.resignationRate;
                            this.form.resignationRateScore = res.data.resignationRateScore;
                        }
                    }).finally(() => { this.$emit('computing', false); });
                }, 500);
            }
        },
        setLastMonth() {
            this.form.assessmentMonth = dayjs().subtract(1, 'month').format('YYYY-MM');
        },
        clear() {
            clearTimeout(this.computeTimeout);
            this.form = { ...INIT_FORM };
            this.$nextTick(() => {
                this.$refs.formRef.clearValidate();
            });
        },
        validate() {
            return this.$refs.formRef.validate();
        },
        isHeightLightLabel(prop) {
            return this.changeKeys.includes(prop);
        }
    },
    created() {
        // console.log('---operateType',this.operateType)
        dictWithUrl('SRM_OPERATIONAL_QUALITY').then(res => {
            if (res && +res.code === 0) {
                this.dict = res.data;
            }
        });
    }
};
</script>
<style lang="less">
.performance-assess-detail-score-form {
    .el-col {
        line-height: 1.5em;
    }

    // .align-center {
    //     text-align: center;
    // }

    .flex-row .el-col {
        display: flex;
    }

    .big-bold-text {
        font-size: 14px;
        font-weight: bold;
    }

    .label-span {
        display: inline-block;
        padding-right: 12px;
        width: 160px;
        text-align: right;
        box-sizing: border-box;
        flex-shrink: 0;
    }

    .value-span {
        display: inline-block;
    }

    .el-form-item__error {
        white-space: nowrap;
    }

    .mb-18 {
        margin-bottom: 18px;
    }

    .lh-28 {
        line-height: 28px;
    }

    .upload-item .el-input-group__append {
        padding: 0 10px;
    }

    .preview-btn {
        position: absolute;
        right: -34px;
    }

    .detail-preview-btn {
        padding-top: 0;
        padding-bottom: 0;
        margin-left: 10px;
    }

    .height-light-label-item .el-form-item__label {
        color: #f96c5f;
    }
}
</style>